import { render } from "./InputTextarea.vue?vue&type=template&id=5203d7f5"
import script from "./InputTextarea.vue?vue&type=script&lang=js"
export * from "./InputTextarea.vue?vue&type=script&lang=js"

import "./InputTextarea.vue?vue&type=style&index=0&id=5203d7f5&lang=scss"

import exportComponent from "C:\\Server-Testumgebung\\way-academy-app-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__